// extracted by mini-css-extract-plugin
export var aggregationCell = "_2r-n";
export var aggregationRow = "_2r-m";
export var borderlessSpinnerContainer = "_2r-3";
export var cardLayout = "_2r-6";
export var cardLayoutNoFooter = "_2r-9";
export var cardLayoutPageControl = "_2r-8";
export var closeIcon = "_2r-f";
export var columnHeaderSurface = "_2r-b";
export var columnHeaderSurfaceDragOverlay = "_2r-v";
export var columnHeaderSurfaceResizing = "_2r-s";
export var contextMenuAnchor = "_2r-1";
export var draggableColumnHeader = "_2r-t";
export var draggableColumnHeaderOverlay = "_2r-u";
export var expandIcon = "_2r-g";
export var expanded = "_2r-h";
export var filterDropdown = "_2r-i";
export var filterDropdownDivider = "_2r-d";
export var filterDropdownHeader = "_2r-l";
export var filterDropdownItem = "_2r-k";
export var filterDropdownModal = "_2r-j _2r-i";
export var filterItem = "_2r-c";
export var normalCellWithAdjustableBorder = "_2r-e";
export var pinButtonContainer = "_2r-o";
export var pinIcon = "_2r-p";
export var pinIconActive = "_2r-q";
export var spinner = "_2r-0";
export var spinnerContainer = "_2r-2";
export var tableContainer = "_2r-4";
export var tableContentDraggingColumns = "_2r-a";
export var tableContentInner = "_2r-7";
export var tableContentWrapper = "_2r-5";
export var viewButtonContainer = "_2r-r";